export const RESETPASSWORD_CLEAR = 'RESETPASSWORD_CLEAR';
export const RESETPASSWORD_POST_START = 'RESETPASSWORD_POST_START';
export const RESETPASSWORD_POST_FINISH = 'RESETPASSWORD_POST_FINISH';
export const RESETPASSWORD_GET_START = 'RESETPASSWORD_GET_START';
export const RESETPASSWORD_GET_FINISH = 'RESETPASSWORD_GET_FINISH';
export const CHANGEPASSWORD_FINISH = 'CHANGEPASSWORD_FINISH';
export const CHANGEPASSWORD_START = 'CHANGEPASSWORD_START';
